import { Component, Inject } from '@angular/core';
import { MaterialModule } from '../../modules/material/material.module';
import { CommonModule } from '@angular/common';
import { MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import {Clipboard} from '@angular/cdk/clipboard';

@Component({
  selector: 'app-payment-pop-up-dialog',
  imports: [MaterialModule, CommonModule, MatDialogActions, MatDialogClose, MatDialogTitle, MatDialogContent],
  templateUrl: './payment-pop-up-dialog.component.html',
  styleUrl: './payment-pop-up-dialog.component.scss'
})
export class PaymentPopUpDialogComponent {
    title: string = '';
    content: string = '';
    btnLabel: string = '';

    constructor(public dialogRef: MatDialogRef<PaymentPopUpDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private clipboard: Clipboard) {
    this.title = data.title;
    this.content = data.content;
    this.btnLabel = data.btnLabel;
  }

  copyPanToClipboard(): void {
    this.clipboard.copy("4111111111111111");
  }

  copyCvvToClipboard(): void {
    this.clipboard.copy("737");
  }

  copyExpiryToClipboard(): void {
    this.clipboard.copy("03/30");
  }
}
